import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 119 31.5",
    }}
    viewBox="0 0 119 31.5"
    {...props}
  >
    <style>{`.st0{fill:none;stroke:${strokeColor};stroke-miterlimit:10}`}</style>
    <g id="Layer_2_00000078034766437017628660000014651781136001089711_">
      <path
        id="Layer_4_00000012445408901645575590000007929448687252741774_"
        d="M90.4 20c-1.1.4-1.5 1.5-1.5 1.7v1.4c0 .1-.1.1-.1.1l-.1.2-.1.6H31.5v-.6l-.1.1"
        className="st0"
      />
      <path d="M90.1 20.5c0-12.8 21.9-15.3 21.4 1.5" className="st0" />
      <g id="Layer_2_00000155121443628905800900000004859472908403130512_">
        <ellipse cx={100.9} cy={21.1} className="st0" rx={9.5} ry={9.8} />
        <path
          d="M108.2 21.1c0 4.1-3.3 7.1-7.1 7.1S94 24.9 94 21.1s3.3-7.1 7.1-7.1c3.8-.2 7.1 3.3 7.1 7.1z"
          className="st0"
        />
        <path
          d="M108 21.4c-1-.1-2-.2-3-.2-.9-.1-1-1.4-.2-2 .7-.6 1.4-1 2.1-1.5l.1-.2c-.1-.2-.7-1.3-1.3-1.4h-.2l-1.9 1.9c-.7.7-1.9.1-1.9-.7.1-1 .1-2.1.2-3.1-.2-.2-2-.2-2.1 0 .1 1 .1 2.1.2 3.1s-1.2 1.4-1.9.7l-1.9-1.9-1.2 1.5v.2c.6.5 1 .9 1.7 1.3.7.6.6 1.9-.2 2-1 .1-1.3.1-2.4.2l.3 2.1c-.1.1 1.2 0 2.2-.4.7-.2 1.5.7 1.3 1.4-.5.9-.6 1.3-1.2 2.1 0 0 1.2 1 1.4 1 .1 0 .2 0 .2-.1.2-.9.6-1.5.9-2.7.2-.9 1.6-.9 2.1 0 .3.9.6 1.5.9 2.6 0 0 .1.5.2.5.2 0 1.7-.4 1.9-.7.1-.1-.3-.7-.3-.7-.5-.9-.7-1.4-1.3-2.2-.2-.7.2-1.5 1.3-1.4.9.2 2.7.5 3.7.7.1-.2.5-1.6.3-2.1z"
          className="st0"
        />
        <path
          d="M102.1 21c0 .6-.5 1-1 1s-1-.5-1-1 .5-1 1-1c.6-.1 1 .4 1 1z"
          className="st0"
        />
        <circle cx={103.3} cy={21.2} r={0.5} className="st0" />
        <circle cx={99.3} cy={19.8} r={0.5} className="st0" />
        <circle cx={101.5} cy={23.1} r={0.5} className="st0" />
        <circle cx={101.6} cy={18.9} r={0.5} className="st0" />
        <circle cx={99.1} cy={22} r={0.5} className="st0" />
      </g>
      <g id="Layer_2_00000016073657216702278980000013240535702283208866_">
        <ellipse cx={20.4} cy={21} className="st0" rx={9.5} ry={9.8} />
        <path
          d="M27.7 21c0 4.1-3.3 7.1-7.1 7.1s-7.1-3.3-7.1-7.1 3.3-7.1 7.1-7.1c3.8-.2 7.1 3.3 7.1 7.1z"
          className="st0"
        />
        <path
          d="M27.5 21.3c-1-.1-2-.2-3-.2-.9-.1-1-1.4-.2-2 .7-.6 1.4-1 2.1-1.5l.1-.2c-.1-.2-.7-1.3-1.3-1.4H25l-1.9 1.9c-.7.7-1.9.1-1.9-.7.1-1 .1-2.1.2-3.1-.2-.2-2-.2-2.1 0 .1 1 .1 2.1.2 3.1s-1.2 1.4-1.9.7L15.7 16l-1.2 1.5v.2c.6.5 1 .9 1.7 1.3.7.6.6 1.9-.2 2-1 .1-1.3.1-2.4.2l.3 2.1c-.1.1 1.2 0 2.2-.4.7-.2 1.5.7 1.3 1.4-.5.9-.6 1.3-1.2 2.1 0 0 1.2 1 1.4 1 .1 0 .2 0 .2-.1.2-.9.6-1.5.9-2.7.2-.9 1.6-.9 2.1 0 .3.9.6 1.5.9 2.6 0 0 .1.5.2.5.2 0 1.7-.4 1.9-.7.1-.1-.3-.7-.3-.7-.5-.9-.7-1.4-1.3-2.2-.2-.7.2-1.5 1.3-1.4.9.2 2.7.5 3.7.7.1-.2.5-1.6.3-2.1z"
          className="st0"
        />
        <path
          d="M21.6 20.9c0 .6-.5 1-1 1s-1-.5-1-1 .5-1 1-1c.6-.1 1 .4 1 1z"
          className="st0"
        />
        <circle cx={22.8} cy={21.1} r={0.5} className="st0" />
        <circle cx={18.8} cy={19.7} r={0.5} className="st0" />
        <circle cx={21} cy={23} r={0.5} className="st0" />
        <circle cx={21.1} cy={18.8} r={0.5} className="st0" />
        <circle cx={18.6} cy={21.9} r={0.5} className="st0" />
      </g>
    </g>
    <g id="Layer_3">
      <path
        d="M111 21.5h3.7l.5-.1 2.6-.8c.2-.1.4-.3.4-.7l.1-.5v-.8l-.2-1c-.1-.3 0-.7.1-1l.2-.5-.2-4.6v-.9c0-.2-1-1-1.1-1.2l-.6-1.6M9.7 22.8l-4.6.1-.8.2c-.6 0-1.5-.3-1.3-.4l-.6-.6-1.3-1.2c-.5-.5-.5-1.2-.1-1.7l1-1.4c.2-.3.3-.6.2-1l-.8-3.7c0-.2-.1-.4-.1-.6l.2-6.1.1-.7c0-.3.1-.5.3-.7M116.5 7.4H111c-2 0-3.6-1.6-3.6-3.6l.4-1.6 5 2c.6.2 1.1.6 1.6 1l2.1 2c.1.1 0 .2 0 .2zM93.3 6.6h3.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-3.1c-.5 0-.9.4-.9.9s.4.9.9.9zM107.8 2.2 104.5.9M9.2 20.4c0-13.4 22.6-16 22.1 1.5M31.3 21.2l.1 2.8M9.2 19.7v3.5"
        className="st0"
      />
    </g>
  </svg>
);
export default SvgComponent;
